export class Credential {
  public name: string;
  public login: string;
  public userId: string;
  public userContextId?: string;
  public contextId?: string;
  public accessToken: string;
  public refreshToken: string;
  public temporaryPassword: boolean;
  public moduleId?: any;
  public cometChatAuthToken?: string;
  public cometChatUid?: string;
  public profile?: string;
}
